<template>
  <div id="dispatcher">
    <Menutop></Menutop>

      <div class="row container">
        <div class="col">

          <h1>Hier ist frontend/dispatcher</h1>

          <ul>
            <li><a href="/frontend">home</a></li>
            <li><a href="/frontend/#/cropme">cropme (Dispatcher)</a></li>
            <li><a href="/frontend/#/cropme/gevelsberg">cropme/gevelsberg</a></li>
            <li><a href="/frontend/#/uploadcover">uploadcover</a></li>
            <li><a href="/frontend/#/statistik">statistik</a></li>
            <li><a href="/frontend/#/public">public</a></li>
            <li><a href="/api/alle/statistik">api/alle/statistik</a></li>
            <li><a href="/frontend/#/login">login</a></li>
          </ul>

      </div>
    </div>
    <Footer></Footer>
  </div>
</template>


<script>
import Menutop from '../components/Menutop.vue';
import Footer from '../components/Footer.vue';

export default {
  name: 'Dispatcher',
  components: {
    Menutop,
    Footer
  }
}

</script>
